/**
 * Status Cell Renderer
 *
 * Renders the vulnerability status badge with visual indicators.
 * Displays current lifecycle status (Opened, Triaged, Remediated, Accepted, Deleted).
 */

import React from 'react';

import type { RiskWithVulnerability } from '@/hooks/useRisks';
import { VulnerabilityStatusComponent } from '@/sections/vulnerabilities/components/VulnerabilityStatus';

interface StatusCellProps {
  risk: RiskWithVulnerability;
}

/**
 * Memoized cell renderer for vulnerability status column
 *
 * Delegates to VulnerabilityStatusComponent for consistent status rendering.
 * Displays status badge with icon, color coding, and tooltip.
 *
 * @param risk - The vulnerability/risk to render status for
 * @returns VulnerabilityStatusComponent with status badge
 */
export const StatusCell: React.FC<StatusCellProps> = React.memo(({ risk }) => {
  return <VulnerabilityStatusComponent vulnerability={risk} />;
});

StatusCell.displayName = 'StatusCell';
